import { Button } from '@healingpaper/cell'
import { IcIllustStar } from '@healingpaper/cell-icons'

import Text from '@/components/atomic/atoms/Text'
import { generateTagId } from '@/utils/test-automation'
import FlexCol from '@/components/shared/FlexCol'

interface Props {
  text: {
    title: string
    doLogin: string
  }
  onClickLoginButton?: () => void
}

const ReviewLoginCard = ({ text, onClickLoginButton }: Props): JSX.Element => {
  return (
    <div className="relative w-full mt-4 mb-4">
      <FlexCol items="center" gap={16}>
        <IcIllustStar width={72} height={72} />
        <Text element="h3" type="title3" className="whitespace-pre-line text-center">
          {text.title}
        </Text>
        <Button
          id={generateTagId('all', 'paywall', 'btn', 'login', 'review')}
          onClick={() => {
            onClickLoginButton?.()
          }}
          className="w-full h-10 p-0 bg-white text-orange border border-orange shadow-lg"
        >
          {text.doLogin}
        </Button>
      </FlexCol>
    </div>
  )
}

export default ReviewLoginCard
